<script lang="ts">
  import {
    getSocialProofStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type { ISocialProofNode, PartialNode } from "@shared/common/node/type";
  import type { ICampaignSetting } from "@shared/common/types/campaign";
  import type { ISocialProofData } from "@shared/common/types/data-source";
  import { stringTemplateHelper } from "@shared/common/utils/string-template-helper";
  import { getContext } from "svelte";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const campaignSetting = getContext<ICampaignSetting>("campaignSetting");

  const { dataMap, reactionEventListener, t } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<ISocialProofNode>;

  const data = $dataMap[node.id ?? ""] as ISocialProofData | undefined;

  let socialProofData: ISocialProofData = {
    id: node.id ?? "",
    name: "social_proof",
    data: {
      ...(data?.data ? data.data : {}),
      count: (data?.data?.count ?? 0) + (node.socialProof?.adjustment ?? 0),
      type: data?.data?.type ?? "social_proof",
      period: data?.data?.period ?? "7",
      unit: data?.data?.unit ?? "DAY",
      eventType: data?.data?.eventType ?? "PAGEVIEW",
      productId: data?.data?.productId ?? "unknown",
    },
  };

  let content = node.content;
</script>

<div
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
  style={styleToString({
    ...getSocialProofStyle(node, campaignSetting.language),
  })}
>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html stringTemplateHelper({ mode: "VIEW", t: $t }).render(content || "", {
    ...$dataMap,
    socialProof: socialProofData,
  })}
</div>
